import {Box, Typography} from '@mui/material';
import React from 'react';
import './IngetionTabPanelHeader.scss';

interface Props {
  title: string;
  subTitle: string;
}
const IngetionTabPanelHeader: React.FC<Props> = ({title, subTitle}) => {
  return (
    <Box
      className="ingetion-tab-panel-header"
      display="flex"
      flexDirection="column"
    >
      <Typography
        className="typo-text body3_size title-caption"
        tabIndex={0}
        data-testid={`ingetion-tab-panel-header-title`}
      >
        {title}
      </Typography>
      <Typography
        className="typo-text headline3_size sub-title-caption"
        tabIndex={0}
        data-testid={`ingetion-tab-panel-header-typography-subtitle`}
      >
        {subTitle}
      </Typography>
    </Box>
  );
};

export default IngetionTabPanelHeader;
